import { render } from "./ProductsCatalog.vue?vue&type=template&id=e07153d6&scoped=true"
import script from "./ProductsCatalog.vue?vue&type=script&lang=js"
export * from "./ProductsCatalog.vue?vue&type=script&lang=js"

import "./ProductsCatalog.vue?vue&type=style&index=0&id=e07153d6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Rufiz Huseynzada\\OneDrive - Azerbaijan State Oil and Industry University\\Desktop\\ProgressProjects\\AgentModule\\web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e07153d6"]])

export default __exports__